import React, {useRef} from 'react'
import classNames from 'classnames'
import {getImageStyle} from '../../../../../commons/utils/image'
import s from './group-image.scss'

interface GroupImageProps {
  image: wix.common.Image
  className?: string
}

export const GroupImage = ({image, className}: GroupImageProps) => {
  const ref = useRef<HTMLDivElement>(null)
  const container = ref.current?.getBoundingClientRect()

  return (
    <div className={classNames(className, s.root)} ref={ref}>
      {container ? <Image container={container} image={image} /> : null}
    </div>
  )
}

const Image = ({container, image}) => {
  const {src, styles} = getImageStyle({
    image,
    container,
  })
  return <img className={s.img} src={src} style={styles} />
}
